<!-- 水质合格率 -->
<template>
  <div class="m-panel">
    <div class="m-panel-bar">
      <div class="m-panel-bar-title">
        {{title}}
      </div>
    </div>
    <div class="m-panel-body">
      <!-- <div id="chart" style="height: 100%;width: 100%;"></div> -->
      <Echart ref="option" :options="option" style="height: 100%"></Echart>
    </div>
  </div>
</template>
<script>
  import echarts from 'echarts/lib/echarts';
  import {
    postAction
  } from '@/api/manage'
  export default {
    props: {
      titleImage: {
        type: String,
        default: ''
      },
    },
    data() {
      return {
        title: this.$t('水质合格率'),
        url: {
          queryQualified: "/jeecg-charge/wq/index/queryQualified"
        },
        option: {},
      }
    },
    mounted() {},
    methods: {
      init() {
        this.getData();
      },
      getData(){
        postAction(this.url.queryQualified,{}).then(res=>{
          if(res.success){
            var data = res.result;
            this.setOption(data);
          }
        })
      },
      setOption(list) {
        // var chartDom = document.getElementById('chart');
        // var myChart = echarts.init(chartDom);
        var xData = [];
        var yData = [];
        list.map(item=>{
          xData.push(item.remark);
          yData.push(item.passrate*100);
        })
        this.option = {
          textStyle: {
            color: '#fff'
          },
          grid: {
            top: '3%',
            left: '3%',
            right: '3%',
            bottom: '3%',
            containLabel: true
          },
          tooltip: {
              trigger: 'axis',
              formatter: '{b}<br />{a0}: {c0}%',
              backgroundColor: 'rgba(0,11,42,0.9)',
              borderColor: '#5D6A94',
              borderWidth: 1,
              borderRadius: 8,
              textStyle: {
                  color: '#CEE2FF',
              },
              axisPointer: {
                  type: 'line',
                  lineStyle: {
                      color: '#019AF3'
                  }
              }
          },
          legend: {
            show: false,
            top: '3%',
            left: '3%',
            textStyle: {
              color: '#fff'
            },
          },
          xAxis: [{
            type: 'category',
            data: xData,
            splitLine: {
              show: false
            },
            axisTick:{
                show: false
            },
            axisLine: {
                show: false
            },
            axisLabel: {
                color: '#D1F3FF',
                fontSize: 10
            },
            axisPointer: {
              type: 'shadow'
            },
          }],
          yAxis: [{
              type: 'value',
              min:0,
              max:100,
              interval: 20,
              axisLabel: {
                textStyle: {
                    color: '#D1F3FF',
                    fontSize: 12,
                },
                formatter: '{value}%'
              },
              splitLine: {
                  show: true,
                  lineStyle: {
                      type: 'dotted',
                      color: ['#074671'],
                  }
              },
              axisTick:{
                  show: false
              },
              axisLine: {
                  show: false
              },
            },
          ],
          series: [{
              name: this.$t('合格率'),
              type: 'bar',
              barWidth: 20,
              tooltip: {
                formatter: (value) => {
                  return value + '%';
                }
              },
              data: yData,
              itemStyle: {
                normal: {
                  color: '#4634FA',
                  // barBorderRadius: [5, 5, 0, 0],
                }
              },
              label: {
                show: true,
                color: '#D1F3FF',
                position: 'top',
                fontSize: 14,
                formatter: (value) => {
                  return value.value + '%';
                }
              }
            },
          ]
        }
        // option && myChart.setOption(option);
      }
    },
  }
</script>
<style lang="less" scoped>
  .tabs {
    display: flex;
    position: absolute;
    right: 0;
  }

  .tab {
    padding: 6px 8px;
    margin: 0 0 0 0;

    cursor: pointer;
  }

  .tab-active {
    position: relative;
  }

  .tab-active::before {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    content: '';
    height: 2px;
    background-color: #019AF3;
    transition: all .3s;

  }

  .tab:last-child {

    margin-right: 0;
  }

  .tab-title {
    font-size: 12px;
    font-weight: normal;
    color: #7993b3;
    cursor: pointer;
  }

  .tab-active .tab-title {
    color: #cbdff7;
    position: relative;
    font-weight: 500;
  }

  .trends-box {}
  .ant-radio-button-wrapper{
    color: #fff;
    background: transparent;
  }
  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled){
    color: #1890FF;
  }
</style>